import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import EmailDetails from './form/EmailDetails.js';
import Notification from '../../components/Notification.js';
import LoadingSmall from '../../components/LoadingSmall';
import GeneralHandler from '../../modules/General';
import {setSetting} from '../../actions/General.js';
import ChatTranslation from './form/ChatTranslation.js';
import ColorPicker from '../../components/builder/ColorPicker.js';
import ChatTemplate from "./form/ChatTemplate";

import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import Template from "./Template";
import Switch from 'rc-switch';


class SettingsChat extends React.Component {
	constructor(props) {
		super(props);
		 
		this.state = {
			isLoading:true,
			templates:[],
			isSavingTranslation:false,

			isSavingTemplate:false,
			isEditingTemplate:false,
			currentTemplate:false,

			isUpdatingColors:false,
			isUpdating_CHAT_TEXT_BYLINE:false,
			CHAT_TEXT_BYLINE:this.props.general.settings.CHAT_TEXT_BYLINE,
			CHAT_TEXT_BYLINE:this.props.general.settings.CHAT_TEXT_BYLINE,
			isUpdating_CHAT_MINIMIZED_TEXT:false,
			CHAT_MINIMIZED_MESSAGE:this.props.general.settings.CHAT_MINIMIZED_MESSAGE,

            isUpdating_CHAT_POSITION:false,
			CHAT_POSITION:this.props.general.settings.CHAT_POSITION,

            isUpdating_isUpdating_CHAT_OFFLINE_MODE:false,
			CHAT_OFFLINE_MODE:this.props.general.settings.CHAT_OFFLINE_MODE,
			
			

			CHAT_HEADER_BACKGROUND:this.props.general.settings.CHAT_HEADER_BACKGROUND,
			CHAT_HEADER_FONT:this.props.general.settings.CHAT_HEADER_FONT,
			CHAT_BUTTON_BACKGROUND:this.props.general.settings.CHAT_BUTTON_BACKGROUND,
			CHAT_BUTTON_FONT:this.props.general.settings.CHAT_BUTTON_FONT,
			CHAT_VISITOR_BACKGROUND:this.props.general.settings.CHAT_VISITOR_BACKGROUND,
			CHAT_VISITOR_MESSAGE_FONT:this.props.general.settings.CHAT_VISITOR_MESSAGE_FONT,
			CHAT_OPERATOR_BACKGROUND:this.props.general.settings.CHAT_OPERATOR_BACKGROUND,
			CHAT_OPERATOR_MESSAGE_FONT:this.props.general.settings.CHAT_OPERATOR_MESSAGE_FONT,



		}

		this.saveColors = this.saveColors.bind(this);
		this.updateKey = this.updateKey.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
		this.handleTranslationSubmit = this.handleTranslationSubmit.bind(this);
		this.handleTemplateSubmit = this.handleTemplateSubmit.bind(this);
		this.deleteTemplate = this.deleteTemplate.bind(this);
		this.getTemplates = this.getTemplates.bind(this);
	}

    deleteTemplate(id) {
        this.setState({
            isLoading:true,
        });

        axios.delete(`/chat/templates/${id}`)
            .then(res => {
                this.getTemplates();
            })
            .catch(res => {
                this.setState({'isError':'Template not found'});
            });
	}

	saveColors() {
		this.setState({
			isUpdatingColors:true
		});

		let values = {};

		for(let i in this.state) {
			if(i.startsWith('CHAT_')) {
				values[i] = this.state[i];
			}
		}


		axios.put('/settings',values).then(res => {
			this.setState({
				isUpdatingColors:false
			});

			for(let i in values) {
				this.props.setSetting(i,values[i]);
			}

			Notification.success('Success!');
		}).catch(err => {
			this.setState({
				isUpdatingColors:false
			});
		});
	}

	handleColorChange(key,value) {
		this.setState({
			[key]:value
		});
	}

	updateKey(key) {
		
		this.setState({
			['isUpdating'+key]:true
		});

		axios.put('/settings/'+key,{value:this.state[key]}).then(res => {
			this.setState({
				['isUpdating'+key]:false
			});

			this.props.setSetting(key,this.state[key]);

			Notification.success('Success!');
		}).catch(err => {
			this.setState({
				['isUpdating'+key]:false
			});
		});
	}

    handleTemplateSubmit(values) {
		let templates = {
			...this.state.templates,
			values
		}

		this.getTemplates();
	}

	handleTranslationSubmit(values) {
		this.setState({
			isSavingTranslation:true
		});

		axios.put('/settings',values).then(res => {
			this.setState({
				isSavingTranslation:false
			});

			for(let i in values) {
				this.props.setSetting(i,values[i]);
			}
			

			Notification.success('Success!');
		}).catch(err => {
			this.setState({
				isSavingTranslation:false
			});
		});
	}

	handleChange(e) {
		this.setState({
			...this.state,
			[e.target.getAttribute('data-key')]:e.target.value
		});
	}

	getTemplates() {
        this.setState({
            isLoading:true,
        });

        axios.get('/chat').then(res => {
            this.setState({
				isLoading:false,
                templates:res.data.templates,
            })
        });
	}

	componentWillMount() {
		GeneralHandler.fetchGeneral().then(() => {
			this.setState({isLoading:false});
		});
		this.getTemplates();

	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={false} />
		}
		
		return (
			<div className="full-height">
				<Helmet title="Chat | Crall.io" />
				<div className="page-header">
					<span className="page-title"><i className="icon wb-chat"></i> Chat</span>
				</div>

				<div className="page-content">

				<OptionColumn title="Offline Mode" description="Turn off or on Offline mode">

					<div className="col-sm-5">
						<h5>Status</h5>
						<div className="col-sm-12 text-center">
							Off &nbsp;&nbsp;
							<Switch onChange={(val) => {
								if(val) {
									val = 1;
								}else{
									val = 0;
								}
									this.setState({
										CHAT_OFFLINE_MODE:val
									})
								}}
								checked={(this.state.CHAT_OFFLINE_MODE == 1 ? true:false)}
								checkedChildren={<i className="icon fa-check"></i>}
								unCheckedChildren={<i className="icon fa-close"></i>}
							/> &nbsp;On
						</div>
					</div>

					
					<div className="col-sm-6">

						<div className="alert alert-info alert-dismissible" role="alert">
							"Offline mode" will leave the chat visible when all agents are set to "Offline". Visitors can leave a message, and you can reply them when you're online again.
						</div>

					</div>

					<div className="col-sm-12 m-t-10">
					
					</div>
                    {
                        this.props.isUpdating_CHAT_OFFLINE_MODE
                            ?
							<LoadingSmall />
                            :
							<button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.updateKey('CHAT_OFFLINE_MODE')}}>Update</button>
                    }

				</OptionColumn>

				<SplitRows />



				<OptionColumn title="Colors" description="Change chat window colors.">
					<div className="row">




						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Header background</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_HEADER_BACKGROUND} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_HEADER_BACKGROUND' color={this.state.CHAT_HEADER_BACKGROUND} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Header font</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_HEADER_FONT} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_HEADER_FONT' color={this.state.CHAT_HEADER_FONT} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Button background</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_BUTTON_BACKGROUND} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_BUTTON_BACKGROUND' color={this.state.CHAT_BUTTON_BACKGROUND} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Button font</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_BUTTON_FONT} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_BUTTON_FONT' color={this.state.CHAT_BUTTON_FONT} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Visitor chat bubble background</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_VISITOR_BACKGROUND} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_VISITOR_BACKGROUND' color={this.state.CHAT_VISITOR_BACKGROUND} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Visitor chat bubble font</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_VISITOR_MESSAGE_FONT} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_VISITOR_MESSAGE_FONT' color={this.state.CHAT_VISITOR_MESSAGE_FONT} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Operator chat bubble background</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_OPERATOR_BACKGROUND} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_OPERATOR_BACKGROUND' color={this.state.CHAT_OPERATOR_BACKGROUND} handleColorChange={this.handleColorChange} />
							</div>
						</div>

						<div className="form-group col-sm-6">
							<div className="col-sm-9">
								<label className="control-label">Operator chat bubble font</label>
								<input className="form-control" onChange={(e) => {}} value={this.state.CHAT_OPERATOR_MESSAGE_FONT} />
							</div>
							<div className="col-sm-3 p-l-0">
								<label className="control-label">&nbsp;</label>
								<ColorPicker id='CHAT_OPERATOR_MESSAGE_FONT' color={this.state.CHAT_OPERATOR_MESSAGE_FONT} handleColorChange={this.handleColorChange} />
							</div>
						</div>


					</div>

					{
                        this.state.isUpdatingColors
                        ?
                        <LoadingSmall />
                        :
                        <button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.saveColors()}}>Update</button>
                    }
					
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="Position" description="Position of the chat window and bobble.">
					<select className="form-control" onChange={this.handleChange} data-key="CHAT_POSITION" value={this.state.CHAT_POSITION}>
						<option value="left">Bottom left</option>
						<option value="right">Bottom right</option>
					</select>
					<br />
                    {
                        this.props.isUpdating_CHAT_POSITION
                            ?
							<LoadingSmall />
                            :
							<button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.updateKey('CHAT_POSITION')}}>Update</button>
                    }

				</OptionColumn>

				<SplitRows />

				<OptionColumn title="Minimized button text" description="This text will be visible inside the minimized chat bubble.">
					<input type="text" onChange={this.handleChange} data-key="CHAT_MINIMIZED_MESSAGE" value={this.state.CHAT_MINIMIZED_MESSAGE} className="form-control" />
					<br />
					 {
                        this.props.isUpdating_CHAT_MINIMIZED_TEXT
                        ?
                        <LoadingSmall />
                        :
                        <button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.updateKey('CHAT_MINIMIZED_MESSAGE')}}>Update</button>
                    }
					
				</OptionColumn>	

				<SplitRows />

				<OptionColumn title="Byline" description="This message will be displayed for customers first time they're opening a chat window.">
					<textarea placeholder="Type in message.." onChange={this.handleChange} data-key="CHAT_TEXT_BYLINE" value={this.state.CHAT_TEXT_BYLINE} className="form-control"></textarea>
					<br />
					 {
                        this.props.isUpdating_CHAT_TEXT_BYLINE
                        ?
                        <LoadingSmall />
                        :
                        <button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.updateKey('CHAT_TEXT_BYLINE')}}>Update</button>
                    }
					
				</OptionColumn>	

				<SplitRows />

				<OptionColumn title="Translations" description="Translate strings to your native language.">
					<ChatTranslation isSavingTranslation={this.state.isSavingTranslation} onSubmit={this.handleTranslationSubmit} />
				</OptionColumn>

				<OptionColumn title="Templates" description="Predefined message templates">
					<div className="col-sm-12 text-right">
                        {
                            this.state.templates.length > 0 ? <button onClick={e => this.setState({isEditingTemplate:true})} className="btn btn-pure btn-default icon wb-plus"></button>:null
                        }
					</div>
                    {
                        this.state.templates.length > 0 ?
							<table className="table table-striped">
								<tbody>
                                {
                                    this.state.templates.map((template,i) => {
                                        return (
											<tr key={template.id}>
												<td style={{width:'70%'}}>
                                                    {template.name}
												</td>
												<td>
													<div className="btn-group pull-right" role="group">
														<button className="btn btn-icon btn-default btn-outline" onClick={(e) => {e.stopPropagation(); this.setState({isEditingTemplate:true,currentTemplate:template.id})}}><i className="icon wb-pencil" aria-hidden="true"></i></button>
														<button className="btn btn-icon btn-default btn-outline" onClick={(e) => {e.stopPropagation(); this.deleteTemplate(template.id);}}><i className="icon wb-trash" aria-hidden="true"></i></button>
													</div>
												</td>
											</tr>
                                        )
                                    })
                                }
								</tbody>
							</table>:<button onClick={e => this.setState({isEditingTemplate:true})} className="btn btn-dark"><i className="icon wb-plus"></i> Add template</button>
                    }
				</OptionColumn>

				</div>

				<Portal closeOnEsc onClose={e => {this.setState({currentTemplate:false,isEditingTemplate:false})}} isOpened={this.state.isEditingTemplate}>
					<FullScreenOverlay>
						<Template handleSave={this.handleTemplateSubmit} onClose={e => {this.setState({currentTemplate:false,isEditingTemplate:false})}} templateId={this.state.currentTemplate ? this.state.currentTemplate : false}  />
					</FullScreenOverlay>
				</Portal>


			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setSetting},dispatch)
}


SettingsChat = connect(mapStateToProps,mapDispatchToProps)(SettingsChat);
export default SettingsChat;


// WEBPACK FOOTER //
// ./containers/settings/SettingsChat.js